import React from 'react';
import { Carousel as ReactCarousel } from 'react-responsive-carousel';
import { CaoruselWrapper, CarouselItem } from './style';
import { useWindowWidth, WindowWidth } from '../../hooks/useWindowWidth';
export const Carousel = ({ centerSlidePercentage, centerMode, showIndicators, showStatus, showArrows, showThumbs, emulateTouch, infiniteLoop, swipeAble, autoPlay, selectedItem, children, onChange, onClickItem, condensed, }) => {
    const windowWidth = useWindowWidth();
    const getItems = (childItems) => {
        const numItems = React.Children.count(children);
        if (numItems < 3) {
            return [...childItems];
        }
        return childItems;
    };
    const csp = condensed && windowWidth && windowWidth >= WindowWidth.Medium ? 34.1 : centerSlidePercentage ?? 75;
    return (React.createElement(CaoruselWrapper, { condensed: condensed },
        React.createElement(ReactCarousel, { onClickItem: onClickItem, onChange: onChange, showIndicators: showIndicators ?? false, emulateTouch: emulateTouch ?? true, autoPlay: autoPlay ?? false, infiniteLoop: infiniteLoop ?? false, showArrows: showArrows ?? false, showStatus: showStatus ?? false, showThumbs: showThumbs ?? false, swipeable: swipeAble ?? true, centerMode: centerMode ?? true, centerSlidePercentage: csp, selectedItem: selectedItem ?? 0 }, React.Children.map(getItems(children), (child) => (React.createElement(CarouselItem, null, child))))));
};
export default Carousel;
//# sourceMappingURL=Carousel.js.map